import React, { Component } from 'react'
import { PaymentsConfig } from 'containers/forms/payments'
import { meta } from 'helpers/decorators'

@meta({
  title: 'Payments',
  intlKey: 'pageTitle.payment'
})
class OrganizationPayment extends Component {
  render() {
    return <PaymentsConfig isSameLevel />
  }
}

export default OrganizationPayment
